<template>
  <TutorialScreen
    v-show="show"
    :screen-name="$t('stamp.tutorial.title')"
    :screen-info="$t('stamp.tutorial.contactless')"
    @skip="$emit('skip')"
  >
    <TutorialDoll :currentScreen="currentScreen" />
  </TutorialScreen>
</template>

<script>
import autoNext from '@/mixins/auto-next';

import TutorialScreen from '../Screen.vue';
import TutorialDoll from '../TutorialDoll.vue';
import fullBody from '../../../assets/stamp/full-body.svg';

export default {
  name: 'TutorialStart',
  components: {
    TutorialScreen,
    TutorialDoll,
  },
  mixins: [autoNext],
  data: () => ({
    duration: 5,
    audioKey: 'v13_1',
    playThrough: false,
    currentScreen: {
      src: fullBody,
      zoom: 'fullBody',
    },
  }),
};
</script>
